import Vue from 'vue'
import Vuex from 'vuex'
import {
  LOGIN,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGOUT,
  UPDATE_STATUS,
  UPDATE_MOBILE_LOADING,
  CHANGE_AREA_LEVEL,
  CHANGE_SELECTED_PROVINCE,
  CHANGE_SELECTED_DISTRICT,
  CHANGE_SELECTED_ZONE,
  CHANGE_SELECTED_SCHOOL,
  CHANGE_SELECTED_TEACHER,
  CHANGE_MUTATION_INFO,
  CHANGE_FULFILLMENT_DATA,
  TOGGLE_MODAL_PROVINCE,
  TOGGLE_MODAL_DISTRICT,
  TOGGLE_MODAL_ZONE,
  TOGGLE_MODAL_SCHOOL,
  TOGGLE_MODAL_MUTATION,
  TOGGLE_MODAL_RECAP_SCHOOL,
  TOGGLE_MODAL_RECAP_DISTRICT,
  TOGGLE_MODAL_MUTATIONS,
  TOGGLE_MODAL_ABOUT,
  TOGGLE_MODAL_PROFILE,
  DISABLE_TEACHER
} from '@/mutationTypes'
import apiClient from 'api-client'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loginStatus: '',
    token: localStorage.getItem('token') || null,
    user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {
      name: null,
      username: null,
      role: null,
      province: null,
      district: null
    },
    status: null,
    mobileLoading: false,
    areaLevel: 'province',
    selectedProvince: null,
    selectedDistrict: null,
    selectedZone: null,
    selectedSchool: null,
    selectedCourse: null,
    selectedTeacher: null,
    showModalProvince: false,
    showModalDistrict: false,
    showModalZone: false,
    showModalSchool: false,
    showModalMutation: false,
    showModalRecapSchool: false,
    showModalRecapDistrict: false,
    showModalMutations: false,
    modalMutationsType: null,
    showModalAbout: false,
    showModalProfile: false,
    mutationInfo: null,
    fulfillmentData: null,
    disabledTeacher: null
  },
  mutations: {
    [LOGIN_REQUEST] (state) {
      // console.log(LOGIN_REQUEST + ' mutation called')
      state.loginStatus = 'loading'
    },
    [LOGIN_SUCCESS] (state, { token, user }) {
      // console.log(LOGIN_SUCCESS + ' mutation called', token, user)
      state.loginStatus = 'success'
      state.token = token
      state.user = user
    },
    [LOGIN_ERROR] (state) {
      // console.log(LOGIN_ERROR + ' mutation called')
      state.loginStatus = 'error'
    },
    [LOGOUT] (state) {
      // console.log(LOGOUT + ' mutation called')
      state.loginStatus = ''
      state.token = null
      state.user = {
        name: null,
        username: null
      }
    },
    [UPDATE_STATUS] (state, status) {
      // console.log(UPDATE_STATUS + ' mutation called', status)
      state.status = status
    },
    [UPDATE_MOBILE_LOADING] (state, isLoading) {
      // console.log(UPDATE_MOBILE_LOADING + ' mutation called', isLoading)
      state.mobileLoading = isLoading
    },
    [CHANGE_AREA_LEVEL] (state, areaLevel) {
      // console.log(CHANGE_AREA_LEVEL + ' mutation called', areaLevel)
      state.areaLevel = areaLevel
    },
    [CHANGE_SELECTED_PROVINCE] (state, selectedProvince) {
      // console.log(CHANGE_SELECTED_PROVINCE + ' mutation called', selectedProvince)
      state.selectedProvince = selectedProvince
    },
    [CHANGE_SELECTED_DISTRICT] (state, selectedDistrict) {
      // console.log(CHANGE_SELECTED_DISTRICT + ' mutation called', selectedDistrict)
      state.selectedDistrict = selectedDistrict
    },
    [CHANGE_SELECTED_ZONE] (state, selectedZone) {
      // console.log(CHANGE_SELECTED_ZONE + ' mutation called', selectedZone)
      state.selectedZone = selectedZone
    },
    [CHANGE_SELECTED_SCHOOL] (state, selectedSchool) {
      // console.log(CHANGE_SELECTED_SCHOOL + ' mutation called', selectedSchool)
      state.selectedSchool = selectedSchool
    },
    [CHANGE_SELECTED_TEACHER] (state, { selectedTeacher, selectedCourse }) {
      // console.log(CHANGE_SELECTED_TEACHER + ' mutation called', selectedTeacher, selectedCourse)
      state.selectedTeacher = selectedTeacher
      state.selectedCourse = selectedCourse
    },
    [CHANGE_MUTATION_INFO] (state, mutationInfo) {
      // console.log(CHANGE_MUTATION_INFO + ' mutation called', mutationInfo)
      state.mutationInfo = mutationInfo
    },
    [TOGGLE_MODAL_PROVINCE] (state, showModalProvince) {
      // console.log(TOGGLE_MODAL_PROVINCE + ' mutation called', showModalProvince)
      state.showModalProvince = showModalProvince
    },
    [TOGGLE_MODAL_DISTRICT] (state, showModalDistrict) {
      // console.log(TOGGLE_MODAL_DISTRICT + ' mutation called', showModalDistrict)
      state.showModalDistrict = showModalDistrict
    },
    [TOGGLE_MODAL_ZONE] (state, showModalZone) {
      // console.log(TOGGLE_MODAL_ZONE + ' mutation called', showModalZone)
      state.showModalZone = showModalZone
    },
    [TOGGLE_MODAL_SCHOOL] (state, showModalSchool) {
      // console.log(TOGGLE_MODAL_SCHOOL + ' mutation called', showModalSchool)
      state.showModalSchool = showModalSchool
    },
    [TOGGLE_MODAL_MUTATION] (state, showModalMutation) {
      // console.log(TOGGLE_MODAL_MUTATION + ' mutation called', showModalMutation)
      state.showModalMutation = showModalMutation
    },
    [TOGGLE_MODAL_RECAP_SCHOOL] (state, showModalRecapSchool) {
      // console.log(TOGGLE_MODAL_RECAP_SCHOOL + ' mutation called', showModalRecapSchool)
      state.showModalRecapSchool = showModalRecapSchool
    },
    [TOGGLE_MODAL_RECAP_DISTRICT] (state, showModalRecapDistrict) {
      // console.log(TOGGLE_MODAL_RECAP_DISTRICT + ' mutation called', showModalRecapDistrict)
      state.showModalRecapDistrict = showModalRecapDistrict
    },
    [TOGGLE_MODAL_MUTATIONS] (state, { status, type }) {
      // console.log(TOGGLE_MODAL_MUTATIONS + ' mutation called', status)
      state.showModalMutations = status
      state.modalMutationsType = type
    },
    [TOGGLE_MODAL_ABOUT] (state, showModalAbout) {
      // console.log(TOGGLE_MODAL_ABOUT + ' mutation called', showModalAbout)
      state.showModalAbout = showModalAbout
    },
    [TOGGLE_MODAL_PROFILE] (state, showModalProfile) {
      // console.log(TOGGLE_MODAL_PROFILE + ' mutation called', showModalProfile)
      state.showModalProfile = showModalProfile
    },
    [CHANGE_FULFILLMENT_DATA] (state, fulfillmentData) {
      // console.log(CHANGE_FULFILLMENT_DATA + ' mutation called', fulfillmentData)
      state.fulfillmentData = fulfillmentData
    },
    [DISABLE_TEACHER] (state, disabledTeacher) {
      // console.log(DISABLE_TEACHER + ' mutation called', disabledTeacher)
      state.disabledTeacher = disabledTeacher
    }
  },
  getters: {
    isLogin: state => !!state.token
  },
  actions: {
    async [LOGIN] ({ commit, state }, credentials) {
      // console.log(LOGIN + ' action called', credentials)
      commit(LOGIN_REQUEST)
      let login = await apiClient.login({
        username: credentials.username,
        password: credentials.password
      })
      if (login.success) {
        localStorage.setItem('token', login.token)
        localStorage.setItem('user', JSON.stringify(login.user))
        axios.defaults.headers.common['Authorization'] = login.token
        commit(LOGIN_SUCCESS, { token: login.token, user: login.user })
      } else {
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        commit(LOGIN_ERROR)
      }
      return login
    },
    async [LOGOUT] ({ commit, state }) {
      // console.log(LOGOUT + ' action called')
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      commit(LOGOUT)
    },
    async [UPDATE_STATUS] ({ commit, state }, status) {
      // console.log(UPDATE_STATUS + ' action called', status)
      commit(UPDATE_STATUS, status)
    },
    async [UPDATE_MOBILE_LOADING] ({ commit, state }, isLoading) {
      // console.log(UPDATE_MOBILE_LOADING + ' action called', isLoading)
      commit(UPDATE_MOBILE_LOADING, isLoading)
    },
    async [CHANGE_AREA_LEVEL] ({ commit, state }, areaLevel) {
      // console.log(CHANGE_AREA_LEVEL + ' action called', areaLevel)
      commit(CHANGE_AREA_LEVEL, areaLevel)
    },
    async [CHANGE_SELECTED_PROVINCE] ({ commit, state }, selectedProvince) {
      // console.log(CHANGE_SELECTED_PROVINCE + ' action called', selectedProvince)
      // let fulfillmentData = await apiClient.fetchFulfillmentData({
      //   province: selectedProvince,
      //   district: null,
      //   level: selectedLevel
      // })
      commit(CHANGE_SELECTED_PROVINCE, selectedProvince)
      // commit(CHANGE_FULFILLMENT_DATA, fulfillmentData)
    },
    async [CHANGE_SELECTED_DISTRICT] ({ commit, state }, selectedDistrict) {
      // console.log(CHANGE_SELECTED_DISTRICT + ' action called', selectedDistrict)
      // let fulfillmentData = await apiClient.fetchFulfillmentData({
      //   province: selectedDistrict,
      //   district: null,
      //   level: selectedLevel
      // })
      commit(CHANGE_SELECTED_DISTRICT, selectedDistrict)
      // commit(CHANGE_FULFILLMENT_DATA, fulfillmentData)
    },
    async [CHANGE_SELECTED_ZONE] ({ commit, state }, selectedZone) {
      // console.log(CHANGE_SELECTED_ZONE + ' action called', selectedZone)
      // let fulfillmentData = await apiClient.fetchFulfillmentData({
      //   province: selectedZone,
      //   district: null,
      //   level: selectedLevel
      // })
      commit(CHANGE_SELECTED_ZONE, selectedZone)
      // commit(CHANGE_FULFILLMENT_DATA, fulfillmentData)
    },
    async [CHANGE_SELECTED_SCHOOL] ({ commit, state }, selectedSchool) {
      // console.log(CHANGE_SELECTED_SCHOOL + ' action called', selectedSchool)
      // let fulfillmentData = await apiClient.fetchFulfillmentData({
      //   province: selectedSchool,
      //   district: null,
      //   level: selectedLevel
      // })
      commit(CHANGE_SELECTED_SCHOOL, selectedSchool)
      // commit(CHANGE_FULFILLMENT_DATA, fulfillmentData)
    },
    async [CHANGE_SELECTED_TEACHER] ({ commit, state }, data) {
      // console.log(CHANGE_SELECTED_TEACHER + ' action called', data)
      // let fulfillmentData = await apiClient.fetchFulfillmentData({
      //   province: data,
      //   district: null,
      //   level: selectedLevel
      // })
      commit(CHANGE_SELECTED_TEACHER, data)
      // commit(CHANGE_FULFILLMENT_DATA, fulfillmentData)
    },
    async [CHANGE_MUTATION_INFO] ({ commit, state }, mutationInfo) {
      // console.log(CHANGE_MUTATION_INFO + ' action called', mutationInfo)
      // let fulfillmentData = await apiClient.fetchFulfillmentData({
      //   province: selectedTeacher, selectedCourse,
      //   district: null,
      //   level: selectedLevel
      // })
      commit(CHANGE_MUTATION_INFO, mutationInfo)
      // commit(CHANGE_FULFILLMENT_DATA, fulfillmentData)
    },
    async [TOGGLE_MODAL_PROVINCE] ({ commit, state }, showModalProvince) {
      // console.log(TOGGLE_MODAL_PROVINCE + ' action called', showModalProvince)
      commit(TOGGLE_MODAL_PROVINCE, showModalProvince)
    },
    async [TOGGLE_MODAL_DISTRICT] ({ commit, state }, showModalDistrict) {
      // console.log(TOGGLE_MODAL_DISTRICT + ' action called', showModalDistrict)
      commit(TOGGLE_MODAL_DISTRICT, showModalDistrict)
    },
    async [TOGGLE_MODAL_ZONE] ({ commit, state }, showModalZone) {
      // console.log(TOGGLE_MODAL_ZONE + ' action called', showModalZone)
      commit(TOGGLE_MODAL_ZONE, showModalZone)
    },
    async [TOGGLE_MODAL_SCHOOL] ({ commit, state }, showModalSchool) {
      // console.log(TOGGLE_MODAL_SCHOOL + ' action called', showModalSchool)
      commit(TOGGLE_MODAL_SCHOOL, showModalSchool)
    },
    async [TOGGLE_MODAL_MUTATION] ({ commit, state }, showModalMutation) {
      // console.log(TOGGLE_MODAL_MUTATION + ' action called', showModalMutation)
      commit(TOGGLE_MODAL_MUTATION, showModalMutation)
    },
    async [TOGGLE_MODAL_RECAP_SCHOOL] ({ commit, state }, showModalRecapSchool) {
      // console.log(TOGGLE_MODAL_RECAP_SCHOOL + ' action called', showModalRecapSchool)
      commit(TOGGLE_MODAL_RECAP_SCHOOL, showModalRecapSchool)
    },
    async [TOGGLE_MODAL_RECAP_DISTRICT] ({ commit, state }, showModalRecapDistrict) {
      // console.log(TOGGLE_MODAL_RECAP_DISTRICT + ' action called', showModalRecapDistrict)
      commit(TOGGLE_MODAL_RECAP_DISTRICT, showModalRecapDistrict)
    },
    async [TOGGLE_MODAL_MUTATIONS] ({ commit, state }, data) {
      // console.log(TOGGLE_MODAL_MUTATIONS + ' action called', data)
      commit(TOGGLE_MODAL_MUTATIONS, data)
    },
    async [TOGGLE_MODAL_ABOUT] ({ commit, state }, showModalAbout) {
      // console.log(TOGGLE_MODAL_ABOUT + ' action called', showModalAbout)
      commit(TOGGLE_MODAL_ABOUT, showModalAbout)
    },
    async [TOGGLE_MODAL_PROFILE] ({ commit, state }, showModalProfile) {
      // console.log(TOGGLE_MODAL_PROFILE + ' action called', showModalProfile)
      commit(TOGGLE_MODAL_PROFILE, showModalProfile)
    },
    async [DISABLE_TEACHER] ({ commit, state }, disabledTeacher) {
      // console.log(DISABLE_TEACHER + ' action called', disabledTeacher)
      commit(DISABLE_TEACHER, disabledTeacher)
    }
  }
})
